"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SEARCH_RESULTS_HEADER_SKELETON = exports.CATEGORIES_COUNT = exports.BRANDS_COUNT = void 0;
const SEARCH_RESULTS_HEADER_SKELETON = exports.SEARCH_RESULTS_HEADER_SKELETON = 'search-results-header-skeleton';
const BRANDS_COUNT = exports.BRANDS_COUNT = 2;
const CATEGORIES_COUNT = exports.CATEGORIES_COUNT = 1;
